import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    id="Pencil-Square--Streamline-Flex"
  >
    <desc>{'Pencil Square Streamline Icon: https://streamlinehq.com'}</desc>
    <g id="pencil-square--change-document-edit-modify-paper-pencil-write-writing">
      <path
        id="Subtract"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.8475 7.83533c0 1.19183 -0.1217 2.35677 -0.2479 3.48417 -0.1122 1.0029 -0.9152 1.8043 -1.91932 1.9202 -1.13459 0.1311 -2.30699 0.2603 -3.50654 0.2603 -1.19956 0 -2.37196 -0.1292 -3.50655 -0.2603 -1.0041 -0.1159 -1.80712 -0.9173 -1.919332 -1.9202C0.621719 10.1921 0.5 9.02716 0.5 7.83533c0 -1.19182 0.121719 -2.35671 0.247858 -3.48413 0.112212 -1.00294 0.915232 -1.80428 1.919322 -1.92025 1.1346 -0.13103 2.307 -0.2603 3.50656 -0.2603 0.13697 0 0.27359 0.00169 0.40985 0.00487"
        strokeWidth={1}
      />
      <path
        id="Vector"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.2774 1.03311 6.42126 5.40157l-0.52828 2.48068c-0.085 0.39915 0.33174 0.77683 0.722 0.65434l2.47259 -0.77608 3.98293 -4.18432c0.6615 -0.69497 0.5461 -1.85734 -0.2546 -2.56447 -0.782 -0.690562 -1.9185 -0.680985 -2.5385 0.02139Z"
        strokeWidth={1}
      />
    </g>
  </svg>,
) as React.FC<{ className?: string }>;
